import {Component, effect, inject, input, signal} from '@angular/core';
import {Location, NgClass} from "@angular/common";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {PaddockStore} from 'src/app/domain/assets/paddocks/paddock.store';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Router} from '@angular/router';
import {Paddock} from 'src/app/infrastructure/moovement-api/models/asset';
import {PaddockService} from 'src/app/domain/assets/paddocks/paddock.service';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {UserStore} from 'src/app/domain/user/user.store';

@Component({
  selector: 'app-customize-paddock',
  imports: [
    NgClass,
    GenericButtonComponent
],
  templateUrl: './customize-paddock.component.html',
  styleUrl: './customize-paddock.component.css'
})
export class CustomizePaddockComponent {

  id = input.required<string>();

  loading = signal(true);
  paddock = signal<Paddock | undefined>(undefined);

  userStore = inject(UserStore);

  private farmStore = inject(FarmStore);
  private location = inject(Location);
  private mainViewStore = inject(MainViewStore);
  private paddockStore = inject(PaddockStore);
  private router = inject(Router);

  constructor(
    private paddockService: PaddockService,
    protected viewportService: ViewportService
  ) {
    effect(() => {
      const loading = this.paddockStore.loading();
      if (loading) return;

      const id = this.id();
      const paddock = this.paddockStore.entityMap()[id];
      if (!paddock) {
        this.router.navigate(["/main/paddocks"]);
        return;
      }

      this.paddock.set(paddock);
      this.loading.set(false);
    });
  }

  back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }

  delete() {
    const farmId = this.farmStore.farm()?.id;
    const paddock = this.paddock();
    if (!farmId || !paddock) return;

    const paddockId = paddock.id;
    const paddockName = paddock.name;
    if (!paddockId || !paddockName || !farmId) return;

    if (!confirm(`Are you sure you want to delete paddock '${paddockName}?'`)) return;

    this.paddockService.deletePaddock(farmId, paddockId);
    this.router.navigate(["/main/paddocks"]);
  }

  async applyChanges() {
    const farmId = this.farmStore.farm()?.id;
    const paddock = this.paddock();
    if (!farmId || !paddock) return;

    this.paddockService.updatePaddock(farmId, paddock);
    this.router.navigate(["/main/paddocks"]);
  }

  setName(name: string) {
    this.paddock.update(paddock => {
      if (!paddock) return paddock;
      return {
        ...paddock,
        name: name
      }
    });
  }
}
